export default class Person {
  constructor (data = {}) {
    this.id = data.id || ''
    this.fullName = data.fullName || ''
    this.avatarURL = data.avatarURL || ''
  }
}
